<template>
<ValidationObserver ref="addressDetails">
  <div>
    <div v-if="!isReadOnly" class="form-group row mb-0">
      <div class="col-8">
        <label class="col-form-label text-left font-weight-bolder pb-0 pt-0">Search for an Address</label>
          <v-autocomplete
            dense
            class="mt-0 pt-0 mb-0" color="white"
            :items="addressCompletionsArray"
            v-model="addressEntity.address"
            :search-input.sync="search"
            @change="getAddressDetails"
            :item-text="getItemText"
            label="Start typing the address (minimum 3 characters)"
            return-object
            :disabled="isReadOnly"
          ></v-autocomplete>
      </div>
    </div>
    <label v-if="!isReadOnly" class="col-form-label text-left font-weight-bolder pb-0 pt-0">Or enter the address manually</label>

    <div class="form-group row mb-0">
      <div class="col-3">
        <label class="col-form-label text-left">Street<span v-if="mandatory && !internal" class="text-danger">*</span></label>
        <ValidationProvider :rules="mandatory && !internal ? 'required|max:255' : 'max:255'" name="addressEntity.streetAddress" v-slot="{ errors }">
          <b-form-input class="form-control" v-model="addressEntity.streetAddress" :disabled="isReadOnly" maxlength="255"
                 @input="notifyAddressChanged" />
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
      <div class="col-3">
        <label class="col-form-label text-left">City/Suburb<span v-if="mandatory && !internal" class="text-danger">*</span></label>
        <ValidationProvider :rules="mandatory && !internal ? 'required|max:255' : 'max:255'" name="addressEntity.suburb" v-slot="{ errors }">
          <b-form-input class="form-control" v-model="addressEntity.suburb" :disabled="isReadOnly" maxlength="255"
                 @input="notifyAddressChanged" />
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
      <div class="col-2">
        <label class="col-form-label text-left">State<span v-if="mandatory" class="text-danger">*</span></label>
        <ValidationProvider :rules="mandatory ? 'required' : ''" name="addressEntity.state" v-slot="{ errors }">
          <b-form-select v-model="addressEntity.state" name="addressEntity.state"
                         :disabled="isReadOnly" @input="notifyAddressChanged"
          >
            <option value="">--Select--</option>
            <option value="NSW">NSW</option>
            <option value="VIC">VIC</option>
            <option value="QLD">QLD</option>
            <option value="WA">WA</option>
            <option value="SA">SA</option>
            <option value="ACT">ACT</option>
            <option value="TAS">TAS</option>
            <option value="NT">NT</option>
            <option value="NT">Overseas</option>
          </b-form-select>
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
      <div class="col-2">
        <label class="col-form-label text-left">Postcode<span v-if="mandatory" class="text-danger">*</span></label>
        <ValidationProvider :rules="mandatory ? 'required|max:10' : 'max:10'" name="addressEntity.postcode" v-slot="{ errors }">
          <b-form-input class="form-control" v-model="addressEntity.postcode" :disabled="isReadOnly" maxlength="10"
                        @input="notifyAddressChanged" />
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
      <div class="col-2">
        <label class="col-form-label text-left">Country<span v-if="mandatory && !internal" class="text-danger">*</span></label>
        <ValidationProvider :rules="mandatory && !internal ? 'required' : ''" name="addressEntity.country" v-slot="{ errors }">
          <b-form-select class="form-control" v-model="addressEntity.country" name="addressEntity.country"
                         :disabled="isReadOnly" @input="notifyAddressChanged"
          >
            <option value="">--Select--</option>
            <option value="Australia">Australia</option>
            <option value="New Zealand">New Zealand</option>
          </b-form-select>
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>
  </div>
</ValidationObserver>
</template>

<style lang="scss">
</style>

<script>
import ApiService from "@/core/services/api.service";

export default {
  name: "AddressDetails",

  props: {
    addressEntity: Object,
    isReadOnly: Boolean,
    mandatory: Boolean,
    internal: Boolean
  },

  data() {
    return {
      search: null,
      addressCompletionsArray: []
    };
  },

  watch: {
    search(searchString) {
      if (!searchString) {
        searchString = "";
      }
      if(searchString.length > 2) {
        this.searchAddress(searchString);
      }
    },
  },

  methods: {
    getItemText: function (item) {
      return `${item.full_address}`;
    },

    searchAddress: function (searchString) {
      if(this.isReadOnly) {
        return;
      }

      ApiService.get(`/mpf/address/search`,
          { params: {searchString: searchString}}
      )
        .then(({ data }) => {
          this.addressCompletionsArray = data.result;
        })
        .catch((error) => {
          console.log("UI Error in searchAddress:", error);
        });
    },

    getAddressDetails: function () {
      if(this.isReadOnly) {
        return;
      }

      let addressId = null;
      if(this.addressEntity && this.addressEntity.address) {
        addressId = this.addressEntity.address.id;
      }

      if (addressId) {
        ApiService.get(`/mpf/address/${addressId}`)
          .then(({ data }) => {
            let userSelectedAddress = data.result;

            this.$set(this.addressEntity, 'postcode', userSelectedAddress.postcode);
            this.$set(this.addressEntity, 'state', userSelectedAddress.state_territory);
            this.$set(this.addressEntity, 'streetAddress', userSelectedAddress.address_line_1 || "");
            this.$set(this.addressEntity, 'suburb', userSelectedAddress.locality_name);
            this.$set(this.addressEntity, 'country', 'Australia');
            if (userSelectedAddress.address_line_2) {
              this.$set(this.addressEntity, 'streetAddress', `${this.addressEntity.streetAddress}, ${userSelectedAddress.address_line_2}`);
            }

            this.notifyAddressChanged();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    notifyAddressChanged: function() {
      this.$emit('addressUpdated', this.addressEntity);
    }
  },
};
</script>
